import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import { Container, Col, Row, Card, CardBody, CardGroup, Form, InputGroup, Input } from 'reactstrap';

import Language from '../../languages/spanish/';

import 'ladda/dist/ladda-themeless.min.css';

class Login extends Component {
 constructor(props) {
  super(props);
  this.state = {
   status: '',
   address: '',
   password: '',
   loading: false
  }

  this.doLogin = this.doLogin.bind(this);
  this.handleChange = this.handleChange.bind(this);
 }

 doLogin(event) {
  event.preventDefault();
  if(this._isMounted) this.setState({status:'', loading: true});
  this.props.getLogin(this.state.address, this.state.password).then((response) => {
   if(this._isMounted) this.setState({loading: false});
  }).catch((error) => {
   console.log(error);
   if(this._isMounted) this.setState({loading: false});
  });
 }

 handleChange(event) {
  var stateObject = {};
  stateObject[event.target.name] = event.target.value;
  this.setState(stateObject);
 }

 componentDidMount() {
  this._isMounted = true;
  if(this.state.uuid) this.getUserToken();
 }
 
 componentWillUnmount() {
  this._isMounted = false;
 }

 render() {
  return (
   <div className="app flex-row align-items-center">
    <Container>
     <Row className="justify-content-center">
      <Col md="8">
       <CardGroup>
        <Card className="p-4">
         <CardBody>
         <Form onSubmit={this.doLogin}>
           <h1>{Language.Login.title}</h1>
           <p className="text-muted">{Language.Login.subtitle}</p>
           
           <InputGroup className="mb-3">
            <div className="input-group-prepend">
             <span className="input-group-text"><i className="icon-user"></i></span>
            </div>
            <Input type="text" className={this.state.status} name="address" value={this.state.address} onChange={this.handleChange} placeholder={Language.Login.username} />
           </InputGroup>

           <InputGroup className="mb-4">
            <div className="input-group-prepend">
             <span className="input-group-text"><i className="icon-lock"></i></span>
            </div>
            <Input type="password" className={this.state.status} name="password" value={this.state.password} onChange={this.handleChange} placeholder={Language.Login.password} />
           </InputGroup>

           <Row>
            <Col xs="6">
             <LaddaButton
              type="submit"
              className="btn btn-success btn-ladda" 
              data-style={EXPAND_LEFT} 
              loading={this.state.loading}>
              {Language.Login.submit}
             </LaddaButton>
            </Col>
            <Col xs="6" className="text-right">
             <Link to="/forgotten" className="px-0">{Language.Login.forgotten}</Link>
            </Col>
           </Row>
          </Form>
         </CardBody>
        </Card>
       </CardGroup>
      </Col>
     </Row>
    </Container>
   </div>
  );
 }

}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Auth/Login.js